import { render, staticRenderFns } from "./ModattaOfferPollSnapTabs.vue?vue&type=template&id=9213d522&scoped=true"
import script from "./ModattaOfferPollSnapTabs.vue?vue&type=script&lang=js"
export * from "./ModattaOfferPollSnapTabs.vue?vue&type=script&lang=js"
import style0 from "./ModattaOfferPollSnapTabs.vue?vue&type=style&index=0&id=9213d522&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9213d522",
  null
  
)

export default component.exports